import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const CardLoader = ({ 
  count = 1, 
  type = 'event', 
  cardStyle = '',
  className = '',
  showImage = true,
  showPrice = true
}) => {
  const renderEventCard = () => (
    <div className="card-loader-event bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden animate-pulse">
      {showImage && (
        <div className="skeleton-image bg-gray-200 h-48 w-full"></div>
      )}
      <div className="p-4 space-y-3">
        <div className="skeleton-title bg-gray-200 rounded h-5 w-3/4"></div>
        <div className="skeleton-date bg-gray-200 rounded h-4 w-1/2"></div>
        <div className="skeleton-location bg-gray-200 rounded h-4 w-2/3"></div>
        {showPrice && (
          <div className="skeleton-price bg-gray-200 rounded h-6 w-20"></div>
        )}
      </div>
    </div>
  );

  const renderSimpleCard = () => (
    <div className="card-loader-simple bg-white rounded-lg shadow-sm border border-gray-100 p-4 animate-pulse">
      <div className="skeleton-content space-y-3">
        <div className="skeleton-title bg-gray-200 rounded h-5 w-3/4"></div>
        <div className="skeleton-text bg-gray-200 rounded h-4 w-full"></div>
        <div className="skeleton-text bg-gray-200 rounded h-4 w-2/3"></div>
      </div>
    </div>
  );

  const renderCard = () => {
    switch (type) {
      case 'event':
        return renderEventCard();
      case 'simple':
        return renderSimpleCard();
      default:
        return renderEventCard();
    }
  };

  if (count === 1) {
    return (
      <div className={`card-loader ${className}`}>
        {renderCard()}
      </div>
    );
  }

  return (
    <div className={`card-loader grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-6 ${className}`}>
      {[...Array(count)].map((_, index) => (
        <div key={index} className={`${cardStyle}`}>
          {renderCard()}
        </div>
      ))}
    </div>
  );
};

CardLoader.propTypes = {
  count: PropTypes.number,
  type: PropTypes.oneOf(['event', 'simple']),
  className: PropTypes.string,
  showImage: PropTypes.bool,
  showPrice: PropTypes.bool,
};

export default CardLoader;
